import PropTypes from 'prop-types';

export const propTypes = {
  collapsible: PropTypes.bool,
  className: PropTypes.string,
  links: PropTypes.shape({
    aboutLinks: PropTypes.array.isRequired,
    appLinks: PropTypes.array.isRequired,
    offerLinks: PropTypes.array.isRequired,
    siteSectionLinks: PropTypes.array,
  }).isRequired,
};
